<script setup>
import {ref, reactive, onMounted } from 'vue'
import {Dialog, DialogDescription, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {useBreadStore} from "@bread/js/store"
import Form from "@bread/ui/Pages/Form"
import {useForm} from "@inertiajs/inertia-vue3"
import "vue-select/dist/vue-select.css";
import Select from "@common/Form/Select.vue";
import {pickBy} from "lodash";

const store = useBreadStore()
const props = defineProps({
  filters: Object,
})

const upsellInput = ref(null)
//let filters = reactive(store.getFilters())
let queryFilters = reactive({})
let amount = null

const form = useForm({
  upsell: null,
  filter_upsell: null,
  active: {id: 0, name: 'Niet aanpassen'},
  only_zero: false,
  only_non_zero: false,
  ignore_higher: false,
  ignore_lower: false,
})

onMounted(() => {
  //getAmountOfProductsToBeEdited()
})

const show_bulk_editor = ref(false)
const show_advanced = ref(false)
let result = reactive({text: '', amount: null})

const submit = () => {
  let activeParams = pickBy( props.filters);
  form.post(route("admin.products.update.bulk", {
    filters: activeParams,
    upsell: form.upsell,
    filter_upsell: form.filter_upsell,
    active: form.active,
    only_zero: form.only_zero,
    only_non_zero: form.only_non_zero,
    ignore_higher: form.ignore_higher,
    ignore_lower: form.ignore_lower,
  }))
  show_bulk_editor.value = false
}

const openBulkDialog = ()=>{
  show_bulk_editor.value = true;
  getAmountOfProductsToBeEdited();
}

const getAmountOfProductsToBeEdited = () => {
  let activeParams = pickBy( props.filters);
  axios.get(route('admin.products.bulk-amount', {
    filters: activeParams,
    upsell: form.upsell,
    filter_upsell: form.filter_upsell,
    active: form.active,
    only_zero: form.only_zero,
    only_non_zero: form.only_non_zero,
    ignore_higher: form.ignore_higher,
    ignore_lower: form.ignore_lower,
  })).then(response => {
    result.amount = response.data.amount
  })
}

const toggleAdvanced = () => {
  if (!show_advanced.value) {
    form.ignore_higher = form.ignore_lower = form.only_non_zero = form.only_zero = false
    form.filter_upsell = form.upsell
  }
  updateResultText()
}

const upsellChange = () => {
  form.filter_upsell = form.upsell
  updateResultText()
}

const filterUpsellChange = () => {
  updateResultText()
}

const checkboxUpdated = (name) => {
  if ((form.ignore_higher && form.ignore_lower) || name === 'only_zero' && form.only_zero) {
    form.ignore_higher = form.ignore_lower = form.only_non_zero = false
    form.only_zero = true
  }
  if ((name === 'ignore_higher' && form.ignore_higher) || (name === 'ignore_lower' && form.ignore_lower)) {
    form.only_zero = false
  }
  if (name === 'only_non_zero' && form.only_non_zero) {
    form.only_zero = false
  }
  updateResultText()
}

const updateResultText = () => {
  let value = form.upsell ?? '0.00'
  let filter_value = form.filter_upsell ?? '0.00'
  if (!form.ignore_higher && !form.ignore_lower && !form.only_non_zero && !form.only_zero) {
    result.text = 'Resultaat: De upsell prijs van alle producten zal aangepast worden naar € ' + value
  } else if (form.only_zero) {
    result.text = 'Resultaat: Producten met upsell prijs € 0.00 zullen aangepast worden naar € ' + value
  } else if (form.only_non_zero && !form.ignore_higher && !form.ignore_lower) {
    result.text = 'Resultaat: Producten met upsell prijs NIET GELIJK aan € 0.00 zullen aangepast worden naar € ' + value
  } else if (form.only_non_zero && form.ignore_higher) {
    result.text = 'Resultaat: Producten met upsell prijs NIET GELIJK aan € 0.00 EN KLEINER dan € '+ filter_value +' zullen aangepast worden naar € ' + value
  } else if (form.only_non_zero && form.ignore_lower) {
    result.text = 'Resultaat: Producten met upsell prijs GROTER dan € '+ filter_value +' zullen aangepast worden naar € ' + value
  } else if (form.ignore_higher) {
    result.text = 'Resultaat: Producten met upsell prijs KLEINER dan € '+ filter_value +' zullen aangepast worden naar € ' + value
  } else if (form.ignore_lower) {
    result.text = 'Resultaat: Producten met upsell prijs GELIJK aan € 0.00 EN GROTER dan € '+ filter_value +' zullen aangepast worden naar € ' + value
  }
  getAmountOfProductsToBeEdited()
}


</script>

<template>
  <div class="flex justify-center items-center">
    <div
      class="bg-slate-600 select-none hover:bg-slate-700 cursor-pointer rounded-md px-4 py-2 text-sm font-medium text-white shadow-sm"
      @click="openBulkDialog">
      Bulk aanpassing
    </div>
    <Teleport to="body">
      <TransitionRoot as="template" :show="show_bulk_editor">
        <Dialog as="div" class="relative z-10" @close="show_bulk_editor = false">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                           leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
          </TransitionChild>

          <div class="fixed z-10 inset-0 overflow-y-auto">
            <div class="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <TransitionChild as="template" enter="ease-out duration-300"
                               enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                               enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                               leave-from="opacity-100 translate-y-0 sm:scale-100"
                               leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                <DialogPanel
                  class="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6">
                  <form @submit.prevent="submit">
                    <div>
                      <div class="mt-3 text-center sm:mt-5">
                        <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
                          Upsell prijs in bulk aanpassen
                        </DialogTitle>
                        <DialogDescription v-show="result.amount !== null">
                          <b>{{result.amount}}</b> Producten zullen aangepast worden
                        </DialogDescription>
                      </div>
                      <label class="block mt-2">
                        <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                          Nieuwe upsell Prijs
                        </span>
                        <input @focus="upsellInput = this" :ref="(el) => {!upsellInput ? el.focus() : false;}" v-on:keyup="upsellChange" v-model="form.upsell" type="text"  name="upsell" id="upsell" class="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1" placeholder="0.00">
                      </label>
                      <label class="block mt-2">
                        <Select
                          label="Actief"
                          v-model="form.active.id"
                          :options="[{id: 0, name: 'Niet aanpassen'}, {id: 1, name: 'Actief'}, {id: 2, name: 'Inactief'}]">
                        </Select>
                      </label>

                      <a href="#"
                         @click="show_advanced = !show_advanced; toggleAdvanced()"
                         class="underline text-blue-500 mt-3 text-sm">
                        geavanceerde instellingen
                      </a>
                      <div v-show="show_advanced">
                        <div class="relative flex items-start mt-2">
                          <div class="flex h-5 items-center">
                            <input v-on:change="checkboxUpdated('only_zero')" v-model="form.only_zero" id="only_zero" aria-describedby="candidates-description" name="only_zero" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500" />
                          </div>
                          <div class="ml-3 text-sm">
                            <label for="only_zero" class="font-medium text-gray-700">Pas enkel producten met upsell prijs € 0,00 aan</label>
                          </div>
                        </div>
                        <div class="relative flex items-start mt-2">
                          <div class="flex h-5 items-center">
                            <input v-on:change="checkboxUpdated('only_non_zero')" v-model="form.only_non_zero" id="only_non_zero" aria-describedby="candidates-description" name="only_non_zero" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500" />
                          </div>
                          <div class="ml-3 text-sm">
                            <label for="only_non_zero" class="font-medium text-gray-700">Pas enkel producten met upsell prijs > € 0,00 aan</label>
                          </div>
                        </div>
                        <div class="relative flex items-start mt-2">
                          <div class="flex h-5 items-center">
                            <input v-on:change="checkboxUpdated('ignore_higher')" v-model="form.ignore_higher" id="ignore_higher" aria-describedby="candidates-description" name="ignore_higher" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500" />
                          </div>
                          <div class="ml-3 text-sm">
                            <label for="ignore_higher" class="font-medium text-gray-700">Pas geen waarden aan waarvan upsell prijs hoger is dan de filter prijs</label>
                          </div>
                        </div>
                        <label class="block mt-2" v-show="form.ignore_higher">
                          <span class="after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                            Filter prijs
                          </span>
                          <input v-on:keyup="filterUpsellChange" v-model="form.filter_upsell" type="text"  name="filter_upsell" id="filter_upsell" class="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1" placeholder="0.00">
                        </label>
                        <div class="relative flex items-start mt-2" >
                          <div class="flex h-5 items-center">
                            <input v-on:change="checkboxUpdated('ignore_lower')" v-model="form.ignore_lower" id="ignore_lower" aria-describedby="candidates-description" name="ignore_lower" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500" />
                          </div>
                          <div class="ml-3 text-sm">
                            <label for="ignore_lower" class="font-medium text-gray-700">Pas geen waarden aan waarvan upsell prijs lager is dan de filter prijs; uitgezonderd € 0.00</label>
                          </div>
                        </div>
                        <label class="block mt-2" v-show="form.ignore_lower">
                          <span class="after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                            Filter prijs
                          </span>
                          <input v-on:keyup="filterUpsellChange" v-model="form.filter_upsell" type="text"  name="filter_upsell" id="filter_upsell" class="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1" placeholder="0.00">
                        </label>
                        <div class="mt-3 text-s text-red-800">{{result.text}}</div>
                      </div>
                    </div>
                    <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                      <button type="submit"
                              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-2 sm:text-sm"
                      >
                        Submit
                      </button>
                      <button type="button"
                              class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                              @click="show_bulk_editor = false"
                              ref="cancelButtonRef">
                        Cancel
                      </button>
                    </div>
                  </form>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </TransitionRoot>
    </Teleport>
  </div>
</template>

<style>
:root {
  --vs-dropdown-max-height: 200px;
}
</style>
